/*eslint no-param-reassign: "error"*/
import { createSlice } from '@reduxjs/toolkit';
import dayjs from '../../dayjs/dayjs_timezone';

const initialState = {
  loading: false,
  locationLoading: false,
  locations: [],
  meta: {},
  products: [],
  selectedLocation: null,
  start: dayjs(),
  finish: dayjs().add(7, 'days'),
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchLocations(state, action) {
      state.locations = action.payload;
    },
    setSelectedLocation(state, action) {
      state.selectedLocation = action.payload;
    },
    onSetAvailabilityProducts(state, action) {
      state.products = action.payload;
    },
    onSetLocationLoading(state, action) {
      state.locationLoading = action.payload;
    },
    onSetSearchFinish(state, action) {
      state.finish = action.payload;
    },
    onSetSearchLoading(state, action) {
      state.loading = action.payload;
    },
    onSetSearchMeta(state, action) {
      state.meta = action.payload;
    },
    onSetSearchStart(state, action) {
      state.start = action.payload;
    },
  },
});

export const searchActions = searchSlice.actions;

export default searchSlice.reducer;